import {
  registerViewModel,
  registerDataProvider,
  registerController,
  registerAppFlow,
  AppFlow
} from 'mutants-appfx';
import {
  registerBizError
} from 'tplus-api';

import SysInfo from './loginMiddleWare/model/SysInfo';


import {
  setLoginParam,
  setLogoPageInfo,
  registerLoginMiddleWare,
  registerSynchLoginMiddleWare,
  setMinServerFullVersion
} from 'tplus-mobilelogin';
import {mapViewModel} from 'tplus-voucher';

import 'tplus-components-mobile';

import BusLoginStore from './loginMiddleWare/store/LoginStore';
import TemplateUtil from './util/TemplateUtil';

import {controlCodeList,amountCodeList,settlementError,otherError} from './config/bizErrorConst';

import SaledeliveryViewModels from './module_biz/saledelivery/saledeliveryMain/viewModel';
import SaledeliveryView from './module_biz/saledelivery';
import {
  voucherDataProvider,
  voucherSaleAppMenuKey,
  voucherOrderAppMenuKey
} from './module_biz/saledelivery/dataProvider';
import SaledeliveryController from './module_biz/saledelivery/controllers/SaledeliveryController';
import SaledeliveryViewController from './module_biz/saledelivery/viewControllers/SaledeliveryViewController';
import portal from './module_biz/portal'

//registerViewModel('SaledeliveryView', SaledeliveryView,...saledeliveryViewModels);

//setMinServerFullVersion('D15.000.000.0086');

import SaledeliveryEditDetailModel from './module_biz/saledelivery/saledeliveryEditDetail/viewModel';
import SaledeliveryEditDetailView from './module_biz/saledelivery/saledeliveryEditDetail';
//registerViewModel('SaledeliveryEditDetailView', SaledeliveryEditDetailView,...SaledeliveryEditDetailVoucherModel);

import SaledeliveryReferPriceModel from './module_biz/saledelivery/saledeliveryReferPrice/viewModel';
import SaledeliveryReferPriceView from './module_biz/saledelivery/saledeliveryReferPrice';

import SaledeliveryEditVoucherModel from './module_biz/saledelivery/saledeliveryVoucherDetail/viewModel';
import SaledeliveryVoucherDetail from './module_biz/saledelivery/saledeliveryVoucherDetail';
import SaledeliverySettlementModel from './module_biz/saledelivery/saledeliverySettlement/viewModel'
import saledeliverySettlementView from './module_biz/saledelivery/saledeliverySettlement';

// 销售订单的定金多结算
import saledeliveryMultiSettlementView from './module_biz/saledelivery/saledeliveryMultiSettlement';
import SaledeliveryMultiSettlementModel from './module_biz/saledelivery/saledeliveryMultiSettlement/viewModel'

import SaledeliveryPriceAvailableView from  './module_biz/saledelivery/saledeliveryPriceAvailable';
import SaledeliveryPriceAvailableModel from './module_biz/saledelivery/saledeliveryPriceAvailable/viewModel';
//registerViewModel('SaledeliveryVoucherDetailView', saledeliveryVoucherDetail,...SaledeliveryEditVoucherVoucherModel);

import SaledeliveryBatchListView from  './module_biz/saledelivery/saledeliveryBatchList';
import SaledeliveryBatchListModel from './module_biz/saledelivery/saledeliveryBatchList/viewModel';

import PreReceiveseListView from  './module_biz/saledelivery/preReceiveseList';
import PreReceiveseListModel from './module_biz/saledelivery/preReceiveseList/viewModel';

import PromotionModels from './module_biz/saledelivery/promotion/viewModel';
import PromotionPlanListView from './module_biz/saledelivery/promotion/view/PlanList';
import PromotionPlanDetailView from './module_biz/saledelivery/promotion/view/PlanDetail';
import PromotionDetailListView from './module_biz/saledelivery/promotion/view/DetailList';
import PromotionDetailEditView from './module_biz/saledelivery/promotion/view/DetailEdit';
import Inventory from './module_biz/saledelivery/inventory/index';
// registerViewModel('SaledeliveryPromotionView', PromotionPlanListView, ...PromotionModels);
// registerViewModel('PromotionPlanDetailView', PromotionPlanDetailView, ...PromotionModels);
// registerViewModel('PromotionDetailListView', PromotionDetailListView, ...PromotionModels);
// registerViewModel('PromotionDetailEditView', PromotionDetailEditView, ...PromotionModels);

registerController('SaledeliveryController', SaledeliveryController, SaledeliveryViewController);
registerViewModel('SaledeliveryView', mapViewModel({
    index: SaledeliveryView,
    detail: SaledeliveryEditDetailView,
    voucherdetail: SaledeliveryVoucherDetail,
    // 促销相关页面
    promotion: PromotionPlanListView,
    promotionitem: PromotionPlanDetailView,
    promotionlist: PromotionDetailListView,
    promotionedit: PromotionDetailEditView,
    settlement:saledeliverySettlementView,
    prereceiveselist:PreReceiveseListView,
    priceavailable:SaledeliveryPriceAvailableView,
    allbatchlist:SaledeliveryBatchListView,
    referprice:SaledeliveryReferPriceView,
    inventory:Inventory,
    multisettle: saledeliveryMultiSettlementView
  }),
  ...SaledeliveryViewModels,
  ...SaledeliveryEditDetailModel,
  ...SaledeliveryEditVoucherModel,
  ...PromotionModels,
  ...SaledeliverySettlementModel,
  ...SaledeliveryMultiSettlementModel,
  ...SaledeliveryPriceAvailableModel,
  ...SaledeliveryBatchListModel,
  ...SaledeliveryReferPriceModel,
  ...PreReceiveseListModel);
registerDataProvider(voucherSaleAppMenuKey, voucherDataProvider);
registerDataProvider(voucherOrderAppMenuKey, voucherDataProvider);

registerAppFlow(voucherSaleAppMenuKey, new AppFlow(false, false));
registerAppFlow(voucherOrderAppMenuKey, new AppFlow(false, false));

import routers from './module_biz/routers';
import {
  registerRoutes
} from 'mutants-microfx';

//注册路由
registerRoutes(routers);

// const username = 'caizx@chanjet.com';
// const password = '123456';
// const accountFilter = ['2019_08_14', '2019_07_12', '710001', 'api0717test', '000001201907031039','000001201907241145', '131001', '000001201907291319'];

// const username = '17001098922';
// const password = '795878';
// const accountFilter = ['2019_09','000001201908141125','131002'];

// const username = 'lichunc@chanjet.com';
// const password = 'lichun1';
// const accountFilter = ['2019_08_14','000001201908141125'];

//注册登录中间件
registerLoginMiddleWare('setLoginInfo', BusLoginStore.setLoginInfo);
//模板存在则注册同步方法
registerSynchLoginMiddleWare('setVoucherWorkFlow',SysInfo.setVoucherWorkFlow);
registerSynchLoginMiddleWare('setAccountInfos',SysInfo.setAccountInfos);
registerSynchLoginMiddleWare('refreshTemplate',TemplateUtil.refreshTemplate);
registerSynchLoginMiddleWare('getJsTicket',TemplateUtil.refreshTemplate);




//registerLoginMiddleWare('getJsTicket', BusLoginStore.getJsTicket);
//registerLoginMiddleWare('refreshTemplate', TemplateUtil.refreshTemplate);
registerBizError(controlCodeList);
registerBizError(amountCodeList);
registerBizError(settlementError);
//注册登录信息
// setLoginParam({
//   indexPage,
//   username,
//   password,
//   accountFilter,
//   serviceDue
// });
//注册app版本控制
//setAppMinVersion({iosVersion, androidVersion });
//工作圈登录欢迎页信息
// setLogoPageInfo({
//   appName,
//   appDesc,
//   logoSrc
// });
